<template>
    <b-row>
        <b-col cols="12">
            <div class="table-responsive has-options">
                <b-table v-if="indumentarias && indumentarias.length > 0" hover :items="indumentarias" :fields="fields" id="abonados-table">
                    <template #cell(cantidad)="{ item }">
                        {{ item.pivot.cantidad }}
                    </template>
                    <template #cell(talla)="{ item }">
                        {{ item.talla ? item.talla.nombre : '' }}
                    </template>
                    <template #cell(incluida)="{ item }">
                        <span v-if="item.incluida" class="mr-2"><i class="text-green fas fa-check-circle"></i></span>
                        <span v-else class="mr-2"><i class="text-danger fas fa-times-circle"></i></span>
                    </template>
                    <template #cell(recogida)="{ item }">
                        <span v-if="item.pivot.recogida" class="mr-2"><i class="text-green fas fa-check-circle"></i></span>
                        <span v-else class="mr-2"><i class="text-danger fas fa-times-circle"></i></span>
                    </template>
                    <template #cell(observaciones)="{ item }">
                        <p>{{ item.pivot.observaciones }}</p>
                    </template>
                    <template #cell(opciones)="{ item }">
                        <button class="btn small-button" @click="showModal('editar-' + item.id)">Editar</button>
                        <EditarIndumentaria :indumentaria="item" @close="closeModal" @actualizar="terminar()"/>
                    </template>
                </b-table>
                <div v-else>
                    <h3>Este deportista no ha adquirido indumentarias.</h3>
                </div>
            </div>
        </b-col>
        <b-col cols="12" v-if="nombre || numero">
            <hr/>
            <b-row>
                <b-col cols="12">
                    <h3>Nombre: {{ nombre }}</h3>
                </b-col>
                <b-col cols="12">
                    <h3>Número: {{ numero }}</h3>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
    import EditarIndumentaria from './modals/EditarIndumentaria.vue';

    export default {
        props: {
            indumentarias: {
                type: Array,
                required: true
            },
            nombre: {
                type: String,
                required: false,
                default: ''
            },
            numero:  {
                type: String,
                required: false,
                default: ''
            }
        },
        data() {
            return {
                fields: [
                    { key: "nombre", label: "Nombre", class: 'text-center' },
                    { key: "precio", label: "Precio", class: 'text-center' },
                    { key: "talla", label: "Talla", class: 'text-center' },
                    { key: "cantidad", label: "Cantidad", class: 'text-center' },
                    { key: "incluida", label: "Incluida", class: 'text-center' },
                    { key: "recogida", label: "Recogida", class: 'text-center' },
                    { key: "observaciones", label: "Observaciones recogida", class: 'text-center' },
                    { key: "opciones", label: "Opciones", class: 'text-center' }
                ]
            }
        },
        methods: {
            terminar() {
                this.$emit('actualizar');
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            }
        },
        components: { EditarIndumentaria }
    }
</script>